module.exports = __webpack_public_path__ + "img/icon_playstore.025b3c80.svg";